import CitySEOHead from "@/components/feature/CitySEOHead";

interface FAQItem {
  q: string;
  a: string;
}

interface PageSEOConfig {
  cityName: string;
  route: string;
  description: string;
  geoPlacename: string;
  geoPosition: string;
  keywords: string;
  faqs: FAQItem[];
  state?: string;
  stateAbbr?: string;
  statePageName?: string;
  statePageRoute?: string;
}

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CityPageSEO({ config }: { config: PageSEOConfig }) {
  const stateAbbr = config.stateAbbr || "GA";
  const state = config.state || "Georgia";
  const title = `Emergency Passport ${config.cityName}, ${stateAbbr} — Expedited Service | Fast Passport Center`;

  return (
    <CitySEOHead
      city={config.cityName}
      state={state}
      stateAbbr={stateAbbr}
      route={config.route}
      title={title}
      description={config.description}
      geoPlacename={config.geoPlacename}
      geoPosition={config.geoPosition}
      faqs={config.faqs}
      servicesSchema={servicesList}
      keywords={config.keywords}
      statePageName={config.statePageName || state}
      statePageRoute={config.statePageRoute || `/${state.toLowerCase()}`}
    />
  );
}

export { servicesList };